import React, { useCallback, useEffect, useRef, useState } from 'react';

import _ from 'lodash';
import { Button, Paper } from '@material-ui/core';

import API from 'utils/api';
import { useSocket, useSources } from 'hooks';
import { ButtonContainer } from 'components';
import { call } from 'utils';
import { ChatPreview, EventHeader, InteractionList, GamePlay } from '../../shared';

import styles from './AdminEvent.module.scss';

const AdminEvent = ({ location, history }) => {
  const [event, setEvent] = useState({ id: _.get(location, 'state.id') });

  const interactionList = useRef(null);
  const eventHeader = useRef(null);
  const gamePlay = useRef(null);

  const sources = useSources();

  const back = useCallback(
    () => history.push('/dashboard/channel/admin/events'),
    [history]
  );

  const fetchData = useCallback(
    id =>
      API.getChannelEvent(
        id,
        {
          populate: 'channel host game',
          query: JSON.stringify({ active: true }),
        },
        sources
      ).then(({ data }) => (data ? setEvent({ id, ...data }) : back())),
    [sources, back]
  );

  useSocket(
    'webapp/control',
    { join: event.id },
    {
      refreshActiveInteractions: () => call((interactionList.current || {}).reload),
      updateOnline: users => call((eventHeader.current || {}).setOnlineUsers, users),
      eventUpdated: () => fetchData(event.id),
      changeEventState: msg => {
        if (!msg || !msg.event || msg.channel) {
          back();
        }
      },
      newPlay: () => call((gamePlay.current || {}).reload),
    }
  );

  useEffect(() => {
    event.id ? fetchData(event.id) : back();
  }, [event.id, fetchData, back]);

  if (!event._id) {
    return null;
  }

  return (
    <div className={styles.adminEvent}>
      <ButtonContainer position="top">
        <Button onClick={back}>back to event list</Button>
      </ButtonContainer>

      <EventHeader ref={eventHeader} event={event} onClose={back} showHost />

      <div className={styles.body}>
        <div className={styles.left}>
          <GamePlay ref={gamePlay} event={event} />
          <InteractionList ref={interactionList} event={event} actions="analytics" />
        </div>

        <Paper className={styles.right}>
          <ChatPreview event={event} />
        </Paper>
      </div>
    </div>
  );
};

export default AdminEvent;
